var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank13 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 110,
  height: 103,
  viewBox: "0 0 110 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_389)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_389)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM59.9604 59.026H48.6444L48.5624 59.272C48.0704 61.404 47.9064 63.208 47.9064 64.766C47.9064 68.702 48.9724 71.818 51.2684 73.95C53.5644 76.082 57.0084 77.148 61.6824 77.148C66.4384 77.148 70.2924 76.41 73.3264 74.852C76.3604 73.294 78.7384 71.408 80.4604 69.112C82.1824 66.898 83.4124 64.52 84.0684 61.896C84.7244 59.354 85.0524 57.058 85.0524 55.09C85.0524 52.63 84.3964 50.662 83.1664 49.022C81.9364 47.382 79.8864 46.316 77.0984 45.824V45.66C78.7384 45.332 80.2964 44.758 81.7724 43.774C83.2484 42.79 84.4784 41.642 85.5444 40.166C86.6104 38.69 87.4304 37.05 88.0864 35.082C88.7424 33.196 89.0704 31.064 89.0704 28.768C89.0704 25.078 87.8404 22.372 85.4624 20.568C83.0024 18.846 79.5584 17.944 75.0484 17.944C69.3904 17.944 64.7984 19.42 61.3544 22.208C57.9104 24.996 55.5324 29.342 54.3844 35.082H65.2084C65.4544 33.77 65.7824 32.458 66.1924 31.31C66.5204 30.162 67.0124 29.178 67.6684 28.358C68.3244 27.538 69.0624 26.882 69.9644 26.39C70.7844 25.898 71.8504 25.652 73.1624 25.652C74.6384 25.652 75.7044 25.98 76.5244 26.636C77.2624 27.292 77.6724 28.44 77.6724 29.998C77.6724 31.474 77.4264 32.868 77.0984 34.344C76.6884 35.82 76.1144 37.132 75.3764 38.362C74.5564 39.592 73.6544 40.576 72.5064 41.314C71.3584 42.134 70.1284 42.462 68.6524 42.462H64.7984L63.1584 50.17H67.0944C69.3904 50.17 71.0304 50.744 71.8504 51.81C72.6704 52.958 73.1624 54.352 73.1624 55.992C73.1624 57.632 72.9984 59.272 72.6704 60.83C72.3424 62.47 71.7684 63.864 71.1124 65.176C70.4564 66.488 69.5544 67.472 68.4064 68.292C67.2584 69.112 65.8644 69.44 64.2244 69.44C62.4204 69.44 61.1084 69.03 60.3704 68.21C59.6324 67.39 59.3044 66.078 59.3044 64.274C59.3044 62.962 59.4684 61.24 59.9604 59.026Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_389",
  x: -11,
  y: 0.94397,
  width: 120.071,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_389"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_389",
  result: "effect2_dropShadow_1_389"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_389",
  result: "effect3_dropShadow_1_389"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_389",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_389",
  x: 16.8081,
  y: 17.944,
  width: 76.2625,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_389"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_389",
  result: "shape"
})))));
export default SvgRank13;